import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=0a8f95d0&"
import script from "./BarChart.vue?vue&type=script&lang=js&"
export * from "./BarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a8f95d0')) {
      api.createRecord('0a8f95d0', component.options)
    } else {
      api.reload('0a8f95d0', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=0a8f95d0&", function () {
      api.rerender('0a8f95d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/Widgets/BarChart.vue"
export default component.exports